import camelCase from 'lodash.camelcase';
import snakeCase from 'lodash.snakecase';
import mapKeys from 'lodash.mapkeys';
import startsWith from 'lodash.startswith';
import deepObjectMap from './deepObjectMap';

const deepMapKeys = callback => deepObjectMap(object => mapKeys(object, (value, key) => callback(key)));

const deepMapKeysToCamelCase = deepMapKeys(camelCase);
const deepMapKeysToSnakeCase = deepMapKeys(key => (startsWith(key, '_') ? key : snakeCase(key)));

export {
  deepMapKeys,
  deepMapKeysToCamelCase,
  deepMapKeysToSnakeCase,
};
